/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GiustificativiAllegatiResponseDTO
 */
export interface GiustificativiAllegatiResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof GiustificativiAllegatiResponseDTO
     */
    idFileAllegato?: number;
    /**
     * 
     * @type {string}
     * @memberof GiustificativiAllegatiResponseDTO
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the GiustificativiAllegatiResponseDTO interface.
 */
export function instanceOfGiustificativiAllegatiResponseDTO(value: object): value is GiustificativiAllegatiResponseDTO {
    return true;
}

export function GiustificativiAllegatiResponseDTOFromJSON(json: any): GiustificativiAllegatiResponseDTO {
    return GiustificativiAllegatiResponseDTOFromJSONTyped(json, false);
}

export function GiustificativiAllegatiResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): GiustificativiAllegatiResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idFileAllegato': json['idFileAllegato'] == null ? undefined : json['idFileAllegato'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
    };
}

export function GiustificativiAllegatiResponseDTOToJSON(json: any): GiustificativiAllegatiResponseDTO {
    return GiustificativiAllegatiResponseDTOToJSONTyped(json, false);
}

export function GiustificativiAllegatiResponseDTOToJSONTyped(value?: GiustificativiAllegatiResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idFileAllegato': value['idFileAllegato'],
        'fileName': value['fileName'],
    };
}

